import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Board from "./components/Board";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
function App() {
    return (_jsxs("div", { className: "flex flex-col bg-gray-800 text-white lg:flex-row w-full h-screen overflow-auto", children: [_jsxs("div", { className: "flex flex-col items-center justify-center flex-1 w-full lg:w-auto lg:mr-2", children: [_jsx(Header, {}), _jsx(Board, {})] }), _jsx("div", { className: "w-full lg:w-80 lg:fixed lg:right-0 lg:top-0 lg:h-full flex justify-center items-center lg:justify-start lg:items-start", children: _jsx(Sidebar, {}) })] }));
}
export default App;
